export default __webpack_public_path__ + "static/media/painting25.b3824aca.jpeg";